import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import './CompanyHistory.css';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const DeliveryPerformance = () => {
  const [activeSection] = useState('delivery-performance');
  const [deliveryFiles, setDeliveryFiles] = useState(null);
  const customItems = Array.isArray(deliveryFiles?.customItems)
    ? deliveryFiles.customItems
    : [];
  
  const sidebarItems = [
    { name: '납품실적', path: 'delivery-performance' }
  ];

  // 다운로드 핸들러
  const handleDownload = ({ url, filename }) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    const link = document.createElement('a');
    link.href = `/delivery-files/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'site-config', 'delivery-files'));
        setDeliveryFiles(snap.exists() ? snap.data() : null);
      } catch (e) {
        console.error('납품실적 설정 로드 실패:', e);
      }
    };
    load();
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  };


  return (
    <>
      <Sidebar 
        category="납품실적" 
        items={sidebarItems}
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">납품실적</h1>
          
          <div className="delivery-description">
            <p>
              태봉산업기술은 40년간 축적된 기술력과 노하우를 바탕으로 
              다양한 산업 분야에 고품질 열교환기 시스템을 안정적으로 공급하고 있습니다.
            </p>
          </div>
          
          {/* 다운로드 섹션 */}
          <section id="delivery-performance" className="section">
            <h3 className="download-section-title">납품실적 자료 다운로드</h3>
            <div className="delivery-split-container">
              {/* 왼쪽: 산업용 납품실적 */}
              <div className="delivery-left">
                <div className="delivery-card-enhanced">
                  <div className="card-header">
                    <div className="card-icon">
                      <img src="/excel.jpeg" alt="Excel" className="excel-icon" />
                    </div>
                    <div className="card-info">
                      <h4 className="card-title">산업용 납품실적</h4>
                    </div>
                  </div>
                  <div className="card-content">
                    <div className="card-features">
                      <span className="feature-tag">플랜트 설비</span>
                    </div>
                  </div>
                  <button 
                    className="download-btn-enhanced"
                    onClick={() =>
                      handleDownload({
                        url: deliveryFiles?.industrial?.fileUrl,
                        filename: '산업용_납품실적_2021_2024.xlsx',
                      })
                    }
                  >
                    <span className="btn-icon">⬇️</span>
                    <span className="btn-text">다운로드</span>
                  </button>
                </div>
              </div>

              {/* 오른쪽: 컴팩트 유닛 납품실적 */}
              <div className="delivery-right">
                <div className="delivery-card-enhanced">
                  <div className="card-header">
                    <div className="card-icon">
                      <img src="/excel.jpeg" alt="Excel" className="excel-icon" />
                    </div>
                    <div className="card-info">
                      <h4 className="card-title">컴팩트 유닛 납품실적</h4>
                    </div>
                  </div>
                  <div className="card-content">
                    <div className="card-features">
                      <span className="feature-tag">HVAC</span>
                    </div>
                  </div>
                  <button 
                    className="download-btn-enhanced"
                    onClick={() =>
                      handleDownload({
                        url: deliveryFiles?.compact?.fileUrl,
                        filename: 'Compact_Unit_납품실적_2023_2024.xlsx',
                      })
                    }
                  >
                    <span className="btn-icon">⬇️</span>
                    <span className="btn-text">다운로드</span>
                  </button>
                </div>
              </div>
            </div>

            {customItems.length > 0 && (
              <div style={{ marginTop: '2rem' }}>
                <h3 className="download-section-title">추가 자료</h3>
                <div className="delivery-split-container" style={{ gap: '2rem' }}>
                  {customItems.map((it) => (
                    <div key={it.id} className="delivery-left" style={{ flex: 1 }}>
                      <div className="delivery-card-enhanced">
                        <div className="card-header">
                          <div className="card-icon">
                            <img src="/excel.jpeg" alt="Excel" className="excel-icon" />
                          </div>
                          <div className="card-info">
                            <h4 className="card-title">{it.titleKo || '납품실적'}</h4>
                          </div>
                        </div>
                        <div className="card-content">
                          <div className="card-features">
                            {(it.tagKo || '').trim() && (
                              <span className="feature-tag">{it.tagKo}</span>
                            )}
                          </div>
                        </div>
                        <button
                          className="download-btn-enhanced"
                          onClick={() =>
                            handleDownload({
                              url: it.fileUrl,
                              filename: it.fileName || 'delivery.xlsx',
                            })
                          }
                        >
                          <span className="btn-icon">⬇️</span>
                          <span className="btn-text">다운로드</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    </>
  );
};

export default DeliveryPerformance;